import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { CFormLabel as CLabel, CFormInput as CInput, CFormSelect as CSelect, CRow, CCol, CContainer, CFormSelect } from '@coreui/react'

import { format } from 'prettier'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat'
import CustomDatePickingFormatForAddNewPatient from './CustomDatePickingFormatForAddNewPatient'

const AddProviderPatientForm = ({ formData, setFormData, isEditable = true, facility, setFacility, errors }) => {
  const genderOptions = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
  ]

  // const [errors, setErrors] = useState({
  //   FirstName: "",
  //   LastName: "",
  //   DOB: "",
  //   roomNumber: "",
  // });

  const [patientStatus, setPatientStatus] = useState([
    { value: 1, label: 'New Patient' },
    { value: 2, label: 'Follow Up' },
    { value: 3, label: 'Re-Admit' },
  ])

  const [calAge, setCalAge] = useState(0)
  const handleChange = (e) => {
    const { name, value } = e.target
    // validateField(name, value);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleFacility = (e) => {
    const { name, value } = e.target
    // validateField(name, value);
    setFacility((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  function calculateAge(dob) {
    const today = new Date()
    const birthDate = new Date(dob)
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDifference = today.getMonth() - birthDate.getMonth()
    const dayDifference = today.getDate() - birthDate.getDate()
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--
    }
    let data = {
      target: { name: 'Age', value: age },
    }
    handleChange(data)
    return age
  }
  useEffect(() => {
    if (formData.DOB) {
      calculateAge(formData.DOB)
    }
  }, [formData.DOB])

  const selectStatusOption = [
    { value: 'NewPatient', label: 'New Patient' },
    { value: 'Follow Up', label: 'Follow Up' },
    { value: 'Re Admit', label: 'Re Admit' },
  ]

  //   const validateField = (name, value) => {
  //   let message = "";

  //   if (name === "FirstName" && !value.trim()) {
  //     message = "First name is required";
  //   }

  //   if (name === "LastName" && !value.trim()) {
  //     message = "Last name is required";
  //   }

  //   if (name === "DOB" && !value) {
  //     message = "Date of birth is required";
  //   }

  //   if (name === "roomNumber" && !value.trim()) {
  //     message = "Room number is required";
  //   }

  //   setErrors((prev) => ({
  //     ...prev,
  //     [name]: message,
  //   }));
  // };

  const selectedOption = selectStatusOption.find((option) => option.value === formData.Status)

  return (
    <CContainer>
      <CRow className="mb-3">
        <CCol md="6">
          <CLabel htmlFor="firstName">First Name</CLabel>
          <CInput
            type="text"
            className="custom-input"
            id="firstName"
            name="FirstName"
            value={formData.FirstName}
            onChange={handleChange}
            required
            disabled={!isEditable}
            placeholder="Enter first name"
            style={{
              background: '#191919',
              border: '1px solid gray',
              color: 'white',
            }}
          />
          {errors?.FirstName && <small style={{ color: 'red' }}>{errors?.FirstName}</small>}
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="middleName">Middle Name</CLabel>
          <CInput
            type="text"
            className="custom-input"
            id="middleName"
            name="MiddleName"
            value={formData.MiddleName}
            onChange={handleChange}
            disabled={!isEditable}
            placeholder="Enter middle name"
            style={{
              background: '#191919',
              border: '1px solid gray',
              color: 'white',
            }}
          />
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol md="6">
          <CLabel htmlFor="lastName">Last Name</CLabel>
          <CInput
            style={{
              background: '#191919',
              border: '1px solid gray',
              color: 'white',
            }}
            className="custom-input"
            type="text"
            id="lastName"
            name="LastName"
            placeholder="Enter last name"
            value={formData.LastName}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
          {errors.LastName && <small style={{ color: 'red' }}>{errors.LastName}</small>}
        </CCol>
        <CCol md="6" className="flex-column d-flex">
          <CLabel htmlFor="dob">Date of Birth</CLabel>

          {/* mihir */}

          <CustomDatePickingFormatForAddNewPatient
            value={formData.DOB}
            maxDate={new Date()}
            onChange={(e) => {
              setFormData((prev) => ({
                ...prev,
                DOB: e,
              }))
            }}
          />
          {errors.DOB && <small style={{ color: 'red' }}>{errors.DOB}</small>}
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol md="6">
          <CLabel htmlFor="gender">Gender</CLabel>

          <Select
            styles={{
              control: (provided) => ({
                ...provided,
                background: '#191919',
                border: '1px solid gray',
                color: 'white',
                borderRadius: '10px',
                height: '40px',
                boxShadow: 'none',
                '&:hover': {
                  border: '1px solid gray',
                },
              }),
              singleValue: (provided) => ({
                ...provided,
                color: 'white',
              }),
              menu: (provided) => ({
                ...provided,
                background: '#191919',
                color: 'white',
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isFocused ? '#555' : '#191919',
                color: 'white',
              }),
            }}
            value={formData.Gender ? genderOptions.find((option) => option.value === formData.Gender) : null}
            onChange={(selectedOption) =>
              handleChange({
                target: { name: 'Gender', value: selectedOption ? selectedOption.value : '' },
              })
            }
            options={genderOptions}
            isDisabled={!isEditable}
            placeholder="Select Gender"
          />
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="age">Age</CLabel>
          <CInput
            className="custom-input"
            style={{
              background: '#191919',
              border: '1px solid gray',
              color: 'white',
            }}
            placeholder="Enter age"
            id="age"
            name="Age"
            value={formData.Age}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol>
      </CRow>
      {/* <CRow>
        <CCol md="6">
          <div className="my-3">
            <CLabel>Patient Status</CLabel>
            <Select
              placeholder="Select"
              name="Status"
              options={patientStatus}
            // value={formData.Status}
            // onChange={(e) => setFormData((prevData) => ({
            //   ...prevData,
            //   Status: e,
            // }))}
            />
          </div>
        </CCol>

      </CRow> */}
      <CRow className="mb-3">
        <CCol md="6">
          <CLabel htmlFor="facility">Facility</CLabel>
          <CInput
            style={{
              background: '#191919',
              border: '1px solid gray',
              color: 'gray',
            }}
            type="text"
            id="facility"
            name="facility"
            value={facility.facility}
            onChange={handleFacility}
            required
            disabled={true}
          />
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="roomNumber">Room Number</CLabel>
          <CInput
            className="custom-input"
            style={{
              background: '#191919',
              border: '1px solid gray',
              color: 'white',
            }}
            type="text"
            id="roomNumber"
            name="roomNumber"
            placeholder="Enter room number"
            value={facility.roomNumber}
            onChange={handleFacility}
            required
            disabled={!isEditable}
          />
          {errors.roomNumber && <small style={{ color: 'red' }}>{errors.roomNumber}</small>}
        </CCol>
      </CRow>

      <CRow className="mb-3">
        {/* <CCol md="6">
          <CLabel htmlFor="state">State</CLabel>
          <CInput
            type="text"
            id="state"
            name="State"
            value={formData.State}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="city">City</CLabel>
          <CInput
            type="text"
            id="city"
            name="City"
            value={formData.City}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol> */}
      </CRow>
      <CRow className="mb-3">
        {/* <CCol md="6">
          <CLabel htmlFor="zipCode">Zip Code</CLabel>
          <CInput
            type="text"
            id="zipCode"
            name="ZipCode"
            value={formData.ZipCode}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol>
        <CCol md="6">
          <CLabel htmlFor="country">Country</CLabel>
          <CInput
            type="text"
            id="country"
            name="Country"
            value={formData.Country}
            onChange={handleChange}
            required
            disabled={!isEditable}
          />
        </CCol> */}
      </CRow>
    </CContainer>
  )
}

export default AddProviderPatientForm
